import { Image, Select, Stack, StackDivider, StackProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";



import { useLocation } from "react-router-dom";
import { SidebarButton, SidebarButtonMobile } from "./SidebarButton";
import Logo from '../../assets/images/logo.png'
import Links, { SidebarItemType } from "../../routes/Links";
import { useDispatch, useSelector } from "react-redux";


import { RefreshBusinesses } from "../../utils/ReduxUtils";
import { selectBusiness } from "../../reducers/selectionsReducer";

export default function Sidebar(props: StackProps) {
    const location = useLocation();
    const theme = useSelector((state: any) => state.theme.value);
    const businesses = useSelector((state: any) => state.businesses.value);
    const dispatch = useDispatch();
    const [, setBusinessSelected] = useState<string>("0");

    const selectedBusiness = useSelector((state: any) => state.selections.value?.business);
    useEffect(() => {
        if (selectedBusiness === undefined && businesses) {
            const business = businesses[0];
            // console.log(business);
            dispatch(selectBusiness(business));
        }
        // console.log(selectedBusiness?.id);
        setBusinessSelected(selectedBusiness?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBusiness, businesses]);

    const [sidebarItems, setSidebarItems] = useState<SidebarItemType[]>(Links);

    useEffect(() => {
        setSidebarItems(
            sidebarItems.map((sidebarItem: SidebarItemType) => {
                sidebarItem.selected = false;
                if (sidebarItem.link === location.pathname) sidebarItem.selected = true;
                return sidebarItem;
            })
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        RefreshBusinesses();
    }, []);

    function onBusinessSelect(e: any) {
        setBusinessSelected(e.target.value);
        const business = businesses.find((b: any) => String(b.id) === e.target.value);
        dispatch(selectBusiness(business));
    }

    return (
        <Stack
            w={theme?.sidebarClosed ? '6vw' : '20vw'}
            transition={'width 1s'}
            p={4}
            overflowY={'hidden'}
            {...props}
            spacing={6}
            divider={<StackDivider />}
            justify={"center"}
            align={"center"}
            boxShadow={'0px 0px 6px 0px rgba(0,0,0,0.2)'}
            overflowX={'hidden'}
        >
            <Stack
                w={'full'}
                justify={'center'}
                align={"center"}
                spacing={4}
            >
                <Image
                    src={Logo}
                    w={theme?.sidebarClosed ? '100%' : '30%'}
                    draggable={'false'}
                    rounded={'full'}
                    transition={'width 1s'}
                // onClick={() => setIsMobile(!isMobile)}
                />
                {
                    !theme?.sidebarClosed && (
                        <Select size={'md'} w={'full'} onChange={onBusinessSelect} value={selectedBusiness?.id ?? ''}>
                            {!selectedBusiness && <option value="">Please Select</option>}
                            {
                                businesses && businesses.map((b: any, i: any) => (
                                    <option key={i} value={b.id}>{b.businessName ?? b.business_name}</option>
                                ))
                            }
                        </Select>
                    )
                }
            </Stack>
            <Stack h={'full'} py={2} px={theme?.sidebarClosed ? 2 : 4} overflowY={theme?.sidebarClosed ? 'hidden' : 'scroll'}>
                {theme?.sidebarClosed ? (
                    <SidebarNavMobile sidebarItems={sidebarItems} />
                ) : (
                    <SidebarNavDesktop sidebarItems={sidebarItems} />
                )}
            </Stack>
        </Stack>
    )
}

interface SidebarNavProps {
    sidebarItems: SidebarItemType[];
}

export function SidebarNavDesktop({ sidebarItems }: SidebarNavProps) {
    return (
        <Stack spacing={5}>
            {sidebarItems.map((sidebar, idx) => (
                <SidebarButton key={idx} {...sidebar} />
            ))}
        </Stack>
    );
}

export function SidebarNavMobile({ sidebarItems }: SidebarNavProps) {
    return (
        <Stack direction={"column"} overflowY={'hidden'}>
            {sidebarItems.map((sidebar, idx) => (
                <SidebarButtonMobile key={idx} {...sidebar} />
            ))}
        </Stack>
    );
}